function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 9.34,
    height: 1.37,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.22833333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 0.685
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.37,
    width: 9.34,
    height: 8.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 5.745
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.12,
    width: 9.34,
    height: 12.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 16.174999999999997
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.23,
    width: 9.34,
    height: 25.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 34.775
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 47.33,
    width: 9.34,
    height: 27.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3342857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 61.099999999999994
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.87,
    width: 9.34,
    height: 35.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8679999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 92.73
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.59,
    width: 9.34,
    height: 41.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 131.34
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 152.09,
    width: 9.34,
    height: 44.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 174.39000000000001
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 196.69,
    width: 9.34,
    height: 47.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 220.245
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 243.8,
    width: 9.34,
    height: 51.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 269.345
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 294.89,
    width: 9.34,
    height: 51.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 320.87
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.85,
    width: 9.34,
    height: 52.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9339999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 373.06
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 399.27,
    width: 9.34,
    height: 52.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 425.59499999999997
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 451.92,
    width: 9.34,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 480.53000000000003
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 509.14,
    width: 9.34,
    height: 60.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 539.28
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 569.42,
    width: 9.34,
    height: 63.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8679999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 601.4
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 633.38,
    width: 9.34,
    height: 66.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 4.67,
    y: 666.69
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 0,
    width: 20.36,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.52,
    y: 18.885
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 0,
    width: 20.43,
    height: 37.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.915,
    y: 18.885
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.13,
    y: 0,
    width: 21.46,
    height: 37.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.86,
    y: 18.885
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.59,
    y: 0,
    width: 21.77,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.47500000000001,
    y: 18.885
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.36,
    y: 0,
    width: 23.92,
    height: 37.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.32,
    y: 18.885
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.28,
    y: 0,
    width: 29.52,
    height: 37.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.04,
    y: 18.885
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.8,
    y: 0,
    width: 32.61,
    height: 37.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.07625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.10500000000002,
    y: 18.885
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.41,
    y: 0,
    width: 34.78,
    height: 37.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.8,
    y: 18.885
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.19,
    y: 0,
    width: 43.05,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.196666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.715,
    y: 18.885
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.24,
    y: 0,
    width: 44.58,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.53000000000003,
    y: 18.885
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.82,
    y: 0,
    width: 46.23,
    height: 37.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.935,
    y: 18.885
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.05,
    y: 0,
    width: 46.85,
    height: 37.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.295000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.475,
    y: 18.885
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.9,
    y: 0,
    width: 47.82,
    height: 37.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.295000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.81,
    y: 18.885
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 0,
    width: 57.75,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.595,
    y: 18.885
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.48,
    y: 0,
    width: 58.99,
    height: 37.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.295000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.975,
    y: 18.885
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.46,
    y: 0,
    width: 65.86,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5180000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.39,
    y: 18.885
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.32,
    y: 0,
    width: 74.68,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.6600000000001,
    y: 18.885
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 37.77,
    width: 64.27,
    height: 48.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.851
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 62.025000000000006
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 86.27,
    width: 64.27,
    height: 50.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 111.5
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 136.73,
    width: 64.27,
    height: 59.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.963333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 166.62
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 196.52,
    width: 64.27,
    height: 67.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.943846153846153
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 230.335
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 264.14,
    width: 64.27,
    height: 69.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.03375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 298.71
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 333.29,
    width: 64.27,
    height: 69.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.711666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 367.89500000000004
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 402.49,
    width: 64.27,
    height: 71.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 438.225
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 473.97,
    width: 64.27,
    height: 73.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.18142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 510.77000000000004
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 547.57,
    width: 64.27,
    height: 75.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.711666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 585.48
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 623.39,
    width: 64.27,
    height: 76.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.474999999999994,
    y: 661.6949999999999
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.61,
    y: 37.77,
    width: 75.25,
    height: 97.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.840909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.235,
    y: 86.37
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.86,
    y: 37.77,
    width: 83.07,
    height: 97.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.7675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.395,
    y: 86.37
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.92,
    y: 37.77,
    width: 84.22,
    height: 97.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.357777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.03,
    y: 86.37
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.15,
    y: 37.77,
    width: 109.85,
    height: 97.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.075,
    y: 86.37
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.99,
    y: 37.77,
    width: 135.61,
    height: 97.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.795,
    y: 86.37
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561.6,
    y: 37.77,
    width: 138.4,
    height: 97.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.8000000000001,
    y: 86.37
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.61,
    y: 134.97,
    width: 105.38,
    height: 129,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.527142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.3,
    y: 199.47
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.61,
    y: 263.97,
    width: 105.38,
    height: 139.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.708888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.3,
    y: 333.68
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.61,
    y: 403.39,
    width: 105.38,
    height: 144.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.563333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.3,
    y: 475.64
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.61,
    y: 547.89,
    width: 105.38,
    height: 152.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.3,
    y: 623.9449999999999
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 134.97,
    width: 156.82,
    height: 173.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.424444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 257.4,
    y: 221.745
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.81,
    y: 134.97,
    width: 174.05,
    height: 173.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.350000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.83500000000004,
    y: 221.745
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.85,
    y: 134.97,
    width: 190.15,
    height: 173.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.792857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.9250000000001,
    y: 221.745
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 308.52,
    width: 521.01,
    height: 391.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.58909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.495,
    y: 504.26
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.0b3de6f5efb7de19c08d1106a9f3e7f0.svg";
export { ForwardRef as ReactComponent };